import {
  baseLocale,
  deLocalizeHref,
  defineCustomClientStrategy,
  defineCustomServerStrategy,
  getLocale,
  isServer,
  locales,
  overwriteGetLocale,
  toLocale,
} from "./paraglide/runtime.js";
import { PUBLIC_PATHS, localizedPath } from "./seo/site.ts";

export type Locale = (typeof locales)[number];

export type Message = () => string;

export const refusalIn = (
  table: Readonly<Record<string, Message>>,
  code: string | null,
  fallback: Message,
): Message => (code !== null && Object.hasOwn(table, code) ? table[code] : undefined) ?? fallback;

export const labelIn = (
  table: Readonly<Record<string, Message>>,
  key: string,
  fallback: Message,
): string => refusalIn(table, key, fallback)();

export const LOCALE_PARAM = "locale";

export const LOCALE_KEY = "colossus.locale";

export const LOCALES: readonly Locale[] = locales;

export const BASE_LOCALE: Locale = baseLocale;

if (!isServer) {
  defineCustomClientStrategy("custom-chosen", {
    getLocale: () =>
      toLocale(new URLSearchParams(location.search).get(LOCALE_PARAM)) ??
      toLocale(localStorage.getItem(LOCALE_KEY)),
    setLocale: () => undefined,
  });
} else {
  defineCustomServerStrategy("custom-chosen", {
    getLocale: (request) =>
      request === undefined
        ? undefined
        : toLocale(new URL(request.url).searchParams.get(LOCALE_PARAM)),
  });
}

export const catalogLocale = (tag: string): Locale =>
  toLocale(tag) ?? toLocale(new Intl.Locale(tag).language) ?? baseLocale;

export const publicHref = (href: string, locale: string = getLocale()): string => {
  const hash = href.indexOf("#");
  const path = hash === -1 ? href : href.slice(0, hash);
  if (!PUBLIC_PATHS.includes(path)) return href;
  return `${localizedPath(path, locale, baseLocale)}${hash === -1 ? "" : href.slice(hash)}`;
};

export const basePath = (pathname: string): string => deLocalizeHref(pathname);

export { getLocale, overwriteGetLocale };
